import { useCallback, useEffect, useState } from "react";
import { apiFetch } from "../services/api";
import { userCanContribute } from "./userRoles";

/** Count of Proposed entities owned by the signed-in user (confirmed_by_user_id). */
export async function fetchOwnProposedEntityCount() {
  if (!userCanContribute()) return 0;
  try {
    const response = await apiFetch(
      `/api/entity-types/counts?proposed_only=true&submittable_only=true&_t=${Date.now()}`,
      { cache: "no-store", timeout: 10000 }
    );
    if (!response?.ok) return 0;
    const data = await response.json();
    return Math.max(0, Number(data?.total_proposed_entities || 0));
  } catch {
    return 0;
  }
}

export function useOwnProposedEntityCount({ enabled = true } = {}) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(Boolean(enabled));

  const refresh = useCallback(async () => {
    if (!enabled || !userCanContribute()) {
      setCount(0);
      setLoading(false);
      return 0;
    }
    setLoading(true);
    const next = await fetchOwnProposedEntityCount();
    setCount(next);
    setLoading(false);
    return next;
  }, [enabled]);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      setLoading(false);
      return undefined;
    }
    void refresh();
  }, [enabled, refresh]);

  return {
    count,
    hasOwnProposed: count > 0,
    loading,
    refresh,
  };
}
